import { AfterViewInit, Component, Input } from '@angular/core';
import { LandingFormService } from '../../services/landing-form.service';

@Component({
  selector: 'landing-inversores-lead-form',
  templateUrl: './landing-lead-form.component.html',
  styleUrls: ['./landing-lead-form.component.scss'],
})
export class LandingLeadFormComponent implements AfterViewInit {
  @Input() containerId = 'landing-inversores-hs-form';

  constructor(private readonly formService: LandingFormService) {}

  ngAfterViewInit(): void {
    this.formService.loadAndRenderForm(this.containerId);
  }
}
